import Vapi from 'vuex-rest-api'
import http from 'src/http/index'
import {
  deleteSuccess,
  createSuccess,
  beforeRequestReset,
  updateSuccess
} from 'components/utils/storeUtils'

const initialState = () => ({
  vscp: {},
  vscp_entries: null,
  vscp_entry: {},
  vscp_entry_results: null,
  vscp_entry_result: {},
  vscp_templates: null,
  vscp_template: {},
  vscp_template_entry: {},
  vscp_template_entries: null
})

const vscpDepKeys = ['vscp_entries', 'vscp_entry', 'vscp_entry_results', 'vscp_entry_result']
const vscpTemplateDepKeys = ['vscp_template_entries', 'vscp_template_entry', 'vscp_template_entry_results', 'vscp_template_entry_result']

const vscp = new Vapi({
  axios: http.axios,
  baseURL: process.env.API_URL + '/inventarisatie',
  queryParams: true,
  state: initialState()
})
  .get({
    action: 'GET_VSCP',
    property: 'vscp',
    queryParams: true,
    path: ({ id }) => `/vscp/${id}`,
    beforeRequest: beforeRequestReset('vscp', vscpDepKeys, initialState())
  })
  .post({
    action: 'CREATE_VSCP',
    property: 'vscp',
    path: '/vscp',
    onSuccess: createSuccess('vscp', 'vscps')
  })
  .post({
    action: 'UPDATE_VSCP',
    property: 'vscp',
    path: ({ id }) => `/vscp/${id}`
  })
  .delete({
    action: 'DELETE_VSCP',
    property: 'vscp',
    queryParams: true,
    path: ({ id }) => `/vscp/${id}`,
    onSuccess: deleteSuccess('vscp', 'vscps')
  })
  .get({
    action: 'GET_VSCP_ENTRIES_FROM_VSCP',
    property: 'vscp_entries',
    queryParams: true,
    path: ({ id }) => `/vscp/${id}/vscp_entries`,
    beforeRequest: beforeRequestReset('vscp_entry', ['vscp_entry'], initialState())
  })
  .get({
    action: 'GET_VSCP_ENTRY',
    property: 'vscp_entry',
    queryParams: true,
    path: ({ id }) => `/vscp_entry/${id}`
  })
  .post({
    action: 'CREATE_VSCP_ENTRY',
    property: 'vscp_entry',
    path: '/vscp_entry',
    onSuccess: createSuccess('vscp_entry', 'vscp_entries')
  })
  .post({
    action: 'UPDATE_VSCP_ENTRY',
    property: 'vscp_entry',
    path: ({ id }) => `/vscp_entry/${id}`,
    onSuccess: updateSuccess('vscp_entry', 'vscp_entries')
  })
  .delete({
    action: 'DELETE_VSCP_ENTRY',
    property: 'vscp_entry',
    requestConfig: {
      headers: {
        'X-Strmln-Forced-Delete': true
      }
    },
    queryParams: true,
    path: ({ id }) => `/vscp_entry/${id}`,
    onSuccess: deleteSuccess('vscp_entry', 'vscp_entries')
  })
  .get({
    action: 'GET_VSCP_ENTRY_RESULTS_FROM_VSCP_ENTRY',
    property: 'vscp_entry_results',
    queryParams: true,
    path: ({ id }) => `/vscp_entry/${id}/results`,
    beforeRequest: beforeRequestReset('vscp_entry_result', ['vscp_entry_result'], initialState())
  })
  .get({
    action: 'GET_VSCP_ENTRY_RESULT',
    property: 'vscp_entry_result',
    queryParams: true,
    path: ({ id }) => `/vscp_entry_result/${id}`
  })
  .post({
    action: 'CREATE_VSCP_ENTRY_RESULT',
    property: 'vscp_entry_result',
    path: '/vscp_entry_result',
    onSuccess: createSuccess('vscp_entry_result', 'vscp_entry_results')
  })
  .post({
    action: 'UPDATE_VSCP_ENTRY_RESULT',
    property: 'vscp_entry_result',
    path: ({ id }) => `/vscp_entry_result/${id}`
  })
  .delete({
    action: 'DELETE_VSCP_ENTRY_RESULT',
    property: 'vscp_entry_result',
    requestConfig: {
      headers: {
        'X-Strmln-Forced-Delete': true
      }
    },
    queryParams: true,
    path: ({ id }) => `/vscp_entry_result/${id}`,
    onSuccess: deleteSuccess('vscp_entry_result', 'vscp_entry_results')
  })
  .get({
    action: 'GET_VSCP_TEMPLATES',
    property: 'vscp_templates',
    queryParams: true,
    path: `/vscp_template`,
    beforeRequest: beforeRequestReset('vscp_templates', vscpTemplateDepKeys, initialState())
  })
  .get({
    action: 'GET_VSCP_TEMPLATE',
    property: 'vscp_template',
    queryParams: true,
    path: ({ id }) => `/vscp_template/${id}`,
    beforeRequest: beforeRequestReset('vscp_template', vscpTemplateDepKeys, initialState())
  })
  .post({
    action: 'CREATE_VSCP_TEMPLATE',
    property: 'vscp_template',
    path: '/vscp_template',
    onSuccess: createSuccess('vscp_template', 'vscp_templates')
  })
  .post({
    action: 'UPDATE_VSCP_TEMPLATE',
    property: 'vscp_template',
    path: ({ id }) => `/vscp_template/${id}`
  })
  .delete({
    action: 'DELETE_VSCP_TEMPLATE',
    property: 'vscp_template',
    queryParams: true,
    path: ({ id }) => `/vscp_template/${id}`,
    onSuccess: deleteSuccess('vscp_template', 'vscp_templates')
  })
  .get({
    action: 'GET_VSCP_TEMPLATE_ENTRIES_FROM_VSCP_TEMPLATE',
    property: 'vscp_template_entries',
    queryParams: true,
    path: ({ id }) => `/vscp_template/${id}/vscp_template_entries`,
    beforeRequest: beforeRequestReset('vscp_template_entry', ['vscp_template_entry'], initialState())
  })
  .get({
    action: 'GET_VSCP_TEMPLATE_ENTRY',
    property: 'vscp_template_entry',
    queryParams: true,
    path: ({ id }) => `/vscp_template_entry/${id}`
  })
  .post({
    action: 'CREATE_VSCP_TEMPLATE_ENTRY',
    property: 'vscp_template_entry',
    path: '/vscp_template_entry',
    onSuccess: createSuccess('vscp_template_entry', 'vscp_template_entries')
  })
  .post({
    action: 'UPDATE_VSCP_TEMPLATE_ENTRY',
    property: 'vscp_template_entry',
    path: ({ id }) => `/vscp_template_entry/${id}`,
    onSuccess: updateSuccess('vscp_template_entry', 'vscp_template_entries')
  })
  .delete({
    action: 'DELETE_VSCP_TEMPLATE_ENTRY',
    property: 'vscp_template_entry',
    requestConfig: {
      headers: {
        'X-Strmln-Forced-Delete': true
      }
    },
    queryParams: true,
    path: ({ id }) => `/vscp_template_entry/${id}`,
    onSuccess: deleteSuccess('vscp_template_entry', 'vscp_template_entries')
  })
  .getStore()

vscp.mutations.RESET_VSCP_STATE = (state) => {
  const initial = initialState()
  for (let key in state) {
    if (state.hasOwnProperty(key)) {
      state[key] = initial[key]
    }
  }
}

export default vscp
